import { openSalesIQChat } from '../utils/openSalesIQChat';
import CallButton from './CallButton';

const tips = [
  {
    title: 'Start with a backup',
    text: 'Before upgrades or moves, create a fresh backup so your tree is recoverable.',
  },
  {
    title: 'Note your version',
    text: 'Knowing Windows vs Mac and your FTM version helps us give precise steps.',
  },
  {
    title: 'Keep media nearby',
    text: 'If photos are linked from folders, keep those folders available during restore.',
  },
  {
    title: 'Chat early',
    text: 'Stuck mid-install? Open chat before trying random fixes that can complicate things.',
  },
];

export default function GettingStarted() {
  return (
    <section className="t7-section t7-section--wash" id="getting-started">
      <div className="container">
        <div className="grid lg:grid-cols-[1fr_1.1fr] gap-8 lg:gap-12 items-start">
          <div className="t7-head t7-head--rail mb-0">
            <p className="t7-kicker">Preparation</p>
            <h2 className="t7-title">Getting started tips</h2>
            <p className="t7-lead">
              A few habits that make installs, upgrades, and migrations far smoother—especially when
              you are chatting with support.
            </p>
            <div className="t7-actions">
              <CallButton className="t7-btn t7-btn--green" />
              <button type="button" className="t7-btn t7-btn--outline-dark" onClick={openSalesIQChat}>
                Ask a Specialist
              </button>
            </div>
          </div>

          <div className="grid sm:grid-cols-2 gap-4 sm:gap-5">
            {tips.map((tip) => (
              <article
                key={tip.title}
                className="bg-white border border-[#c5d9cb] p-4 sm:p-5 hover:border-[#15803d] transition-colors"
              >
                <h3 className="font-serif text-base sm:text-lg text-[#14201a] mb-2">{tip.title}</h3>
                <p className="text-sm text-[#4d5c54] leading-relaxed m-0">{tip.text}</p>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
